export const blockIconsCommunicationCall = (
	<span className='material-symbols-outlined'>call</span>
);
